import { FORM_METHOD_TYPES } from "../../../../stateCommon/consts";
import { METHOD_TEMPLATES } from "../../../utils/consts";
export const request = options => {
  var _options$collection$c;
  const isPost = ((_options$collection$c = options.collection.cgiInfo) === null || _options$collection$c === void 0 || (_options$collection$c = _options$collection$c.request) === null || _options$collection$c === void 0 ? void 0 : _options$collection$c.type) === 'post';
  const postParams = isPost ? `,
  body:source.body` : '';
  const code = `{ 
    query:source.query${postParams} 
  }`;
  const info = {
    args: [],
    type: FORM_METHOD_TYPES.request,
    tpl: METHOD_TEMPLATES.any.request,
    cgi: 'request',
    params: {
      request: code,
      skipCode: !options.isSql
    }
  };
  return info;
};
//# sourceMappingURL=request.js.map
